const SatisfactionGauge = ({ value = 3 }) => {
    // value should be between 1-5

    const min = 1;
    const max = 5;

    const normalized = (value - min) / (max - min);

    const angle = Math.PI * (1 - normalized);

    const centerX = 100;
    const centerY = 100;

    const needleLength = 70;

    const needleX =
        centerX + needleLength * Math.cos(angle);

    const needleY =
        centerY - needleLength * Math.sin(angle);

    return (
        <div className="flex flex-col items-center mb-3 p-6 bg-white rounded-xl gap-4">
            <div className="text-lg font-semibold text-gray-800 mb-4 text-left w-full">
                User Satisfaction
            </div>
            <svg width="220" height="130" viewBox="0 0 200 120">
                {/* Red */}
                <defs>
                    <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#dc2626" />
                        <stop offset="50%" stopColor="#eab308" />
                        <stop offset="100%" stopColor="#16a34a" />
                    </linearGradient>
                </defs>

                <path
                    d="M20 100 A80 80 0 0 1 180 100"
                    stroke="url(#gaugeGradient)"
                    strokeWidth="18"
                    fill="none"
                    strokeLinecap="round"
                />

                {/* Needle */}
                <line
                    x1={centerX}
                    y1={centerY}
                    x2={needleX}
                    y2={needleY}
                    stroke="black"
                    strokeWidth="4"
                    strokeLinecap="round"
                />

                {/* Center Dot */}
                <circle cx={centerX} cy={centerY} r="6" fill="black" />
            </svg>

            <div className="text-2xl font-bold mt-2">
                {value}/5
            </div>


        </div>
    );
};

export default SatisfactionGauge;